(function () {
  var productId = document.body && document.body.getAttribute("data-product-id");
  if (!productId || typeof window.jQuery === "undefined") {
    return;
  }

  var $ = window.jQuery;
  var selector = "#webyze-product-colors-" + productId;
  var prevArrow =
    '<button class="slick-prev slick-arrow slider-arrow-ver flex justify-center" aria-label="Previous" type="button"><svg viewBox="-4.5 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="#000000" transform="rotate(180)"><path d="M249.365851,6538.70769 C249.770764,6539.09744 250.426289,6539.09744 250.830166,6538.70769 L259.393407,6530.44413 C260.202198,6529.66364 260.202198,6528.39747 259.393407,6527.61699 L250.768031,6519.29246 C250.367261,6518.90671 249.720021,6518.90172 249.314072,6519.28247 C248.899839,6519.67121 248.894661,6520.31179 249.302681,6520.70653 L257.196934,6528.32352 C257.601847,6528.71426 257.601847,6529.34685 257.196934,6529.73759 L249.365851,6537.29462 C248.960938,6537.68437 248.960938,6538.31795 249.365851,6538.70769" transform="translate(-305 -6679) translate(56 160)" fill="#000000"></path></svg></button>';
  var nextArrow =
    '<button class="slick-next slick-arrow slider-arrow-ver flex justify-center" aria-label="Next" type="button"><svg viewBox="-4.5 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="#000000"><path d="M249.365851,6538.70769 C249.770764,6539.09744 250.426289,6539.09744 250.830166,6538.70769 L259.393407,6530.44413 C260.202198,6529.66364 260.202198,6528.39747 259.393407,6527.61699 L250.768031,6519.29246 C250.367261,6518.90671 249.720021,6518.90172 249.314072,6519.28247 C248.899839,6519.67121 248.894661,6520.31179 249.302681,6520.70653 L257.196934,6528.32352 C257.601847,6528.71426 257.601847,6529.34685 257.196934,6529.73759 L249.365851,6537.29462 C248.960938,6537.68437 248.960938,6538.31795 249.365851,6538.70769" transform="translate(-305 -6679) translate(56 160)" fill="#000000"></path></svg></button>';
  var swatches = [];
  var started = false;

  function slidesToShow() {
    var width = $(window).width();
    if (width > 1400) return 10;
    if (width > 1100) return 7;
    if (width > 479) return 6;
    return 5;
  }

  function removeUnavailable() {
    var pid = $(selector);
    if (!pid.length || !swatches.length) return;

    for (var index = swatches.length - 1; index >= 0; index--) {
      var element = swatches[index];
      if (!element.parentElement || !element.parentElement.parentElement || !element.parentElement.parentElement.parentElement) {
        break;
      }
      if (element.classList.contains("swatchUnavailable")) {
        pid.slick("removeSlide", index);
      }
    }

    window.setTimeout(removeUnavailable, 1000);
  }

  function slickify() {
    var root = document.querySelector(selector);
    if (!root || !root.querySelector(".swatchProductColor")) {
      window.requestAnimationFrame(slickify);
      return;
    }

    if (started || typeof $.fn.slick !== "function") {
      if (!started) {
        window.setTimeout(slickify, 50);
      }
      return;
    }

    started = true;
    swatches = document.querySelectorAll(selector + " .swatchProductColor");
    root.style.display = "block";

    $(selector).slick({
      infinite: true,
      dots: false,
      draggable: false,
      slidesToShow: slidesToShow(),
      slidesToScroll: 1,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
    });

    removeUnavailable();
  }

  window.setTimeout(slickify, 1000);
})();
